module.exports = __webpack_public_path__ + "img/warning.e9789099.jpg";